<template>
  <transition name="fade">
    <div class="modal" v-if="show" v-on:click.stop="modalClicked">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <h4>Menu Editor</h4>
        <p>Please input menu detail below</p>

        <div class="formCnt">
          <div class="fieldGroup" :class="{hasError: form.name.error}">
            <label>Name</label>
            <input type="text" class="field" ref="input" placeholder="Menu name..."
              v-model="form.name[lang]" v-on:input="form.name.error = null">
            <div class="fieldError" v-if="form.name.error">{{form.name.error}}</div>
          </div>

          <div class="fieldGroup">
            <label>Descriptions</label>
            <textarea rows="3" type="text" class="field" ref="input"
              placeholder="Menu descriptions..."
              v-model="form.descriptions[lang]"
              v-on:input="form.descriptions.error = null"></textarea>
          </div>

          <div class="fieldGroup">
            <label>Type</label>
            <select class="field" v-model="form.type.model">
              <option>Page</option>
              <!-- <option>Pages</option> -->
              <option>Content</option>
              <option>Directory</option>
              <option>External Link</option>
              <option>Unclickable</option>
            </select>
            <div class="fieldHint" v-if="form.type.model === 'Page'">
              Display specific page when opened
            </div>
            <div class="fieldHint" v-if="form.type.model === 'Pages'">
              Display multiple pages thumbnail
            </div>
            <div class="fieldHint" v-if="form.type.model === 'Content'">
              Go to content detail
            </div>
            <div class="fieldHint" v-if="form.type.model === 'Directory'">
              Display content thumbnail from spefici content directory
            </div>
            <div class="fieldHint" v-if="form.type.model === 'External Link'">
              Go to web url when clicked
            </div>
            <div class="fieldHint" v-if="form.type.model === 'Unclickable'">
              User can not open this menu, only for dropdown's parent purpose
            </div>
          </div>

          <div class="fieldGroup" v-if="form.type.model === 'Page'">
            <label>Page</label>
            <select class="field" v-model="form.page.model">
              <option v-for="p in pages" :key="p.id" :value="p.id">
                {{p.name[lang]}}</option>
            </select>
          </div>

          <div class="fieldGroup" v-if="form.type.model === 'Pages'">
            <label>Page</label>
            <div class="fieldCnt pages" v-for="(item, i) in form.pages.model" :key="`${i}`">
              <select class="field" v-model="item.id">
                <option v-for="p in pages" :key="p.id" :value="p.id">
                  {{p.name[lang]}}
                </option>
              </select>
            </div>
            <div class="btnAdd" v-on:click="addPage">Add more page</div>
          </div>

          <div class="fieldGroup" v-if="form.type.model === 'Content'">
            <label>Content</label>
            <div class="field dd" v-on:click="selectContent">
              <span v-if="!content">Select Content</span>
              <template v-else>
                <div class="productItem">
                  <div class="thumb" v-if="content.thumb && content.thumb[lang]"
                    :style="{'background-image': `url(${content.thumb[lang]})`}">
                  </div>
                  <div class="thumb noImg" v-else></div>
                  <h4>{{content.title[lang]}}</h4>
                  <p v-if="content.description && content.description[lang]">
                    {{content.description[lang].substr(0, 120)}}{{
                    (content.description[lang].length > 120) ? '...' : ''
                  }}</p>
                </div>
              </template>
            </div>
          </div>

          <div class="fieldGroup" v-if="form.type.model === 'Directory'"
            v-on:click="selectDir">
            <label>Directory</label>
            <div class="field dd">
              <span v-if="!dir">Select Directory</span>
              <span v-else class="dirSelected">{{dir.name[lang]}}</span>
            </div>
          </div>

          <div class="fieldGroup" v-if="form.type.model === 'External Link'">
            <label>Url</label>
            <input type="text" class="field" ref="input" placeholder="https://"
              v-model="form.url.model">
          </div>

          <div class="fieldGroup" v-if="!['External Link', 'Unclickable']
            .includes(form.type.model)">
            <label>Breadcrumb</label>
            <div class="toggle" v-on:click="form.breadcrumb.model = !form.breadcrumb.model">
              <div class="radioItem" :class="{on: form.breadcrumb.model}">
                <div class="radioIn">
                  <div class="radioHandle"></div>
                </div>
                Show breadcrumb on page
              </div>
            </div>
          </div>
        </div>

        <div class="modalAction">
          <div class="langSelectorBtn"
            v-on:click.stop="langSelectorOpen = !langSelectorOpen">
            <b>{{lang}}</b>
            <div class="langSelector" v-if="langSelectorOpen"
              v-on:click.stop="doNothing">
              <li v-on:click.stop="selectLang('en')">EN - English</li>
              <li v-on:click.stop="selectLang('id')">ID - Bahasa Indonesia</li>
            </div>
          </div>

          <button class="btn btnSecondary" v-on:click="close()">Cancel</button>
          <button class="btn btnPrimary" v-on:click="handleSubmit" ref="btnPrimary">
            <span>Save</span>
          </button>
        </div>
      </div>
      <ArticleSelector ref="articleSelector"/>
      <ContentDirSelector ref="contentDirSelector"/>
    </div>
  </transition>
</template>

<script>
import ArticleSelector from '@/components/ArticleSelector.vue';
import ContentDirSelector from '@/components/ContentDirSelector.vue';

export default {
  name: 'confirmation',
  components: { ArticleSelector, ContentDirSelector },
  data() {
    return {
      show: false,
      next: null,
      form: {
        name: { id: '', en: '', error: null },
        descriptions: { id: '', en: '' },
        type: { model: '' },
        url: { model: '' },
        page: { model: '' },
        pages: { model: [] },
        breadcrumb: { model: false },
      },
      content: null,
      dir: null,
      loadingPage: true,
      pages: [],
      langSelectorOpen: false,
      lang: 'id',
    };
  },
  methods: {
    modalClicked() {
      this.langSelectorOpen = false;
    },
    selectLang(lang) {
      this.langSelectorOpen = false;
      this.lang = lang;
    },
    open(d, next) {
      this.show = true;
      this.next = next;
      this.form.name.en = '';
      this.form.name.id = '';
      this.form.descriptions.en = '';
      this.form.descriptions.id = '';
      this.form.name.error = null;
      this.form.type.model = 'Page';
      this.form.page.model = '';
      this.form.pages.model = [];
      this.form.breadcrumb.model = true;
      this.lang = 'id';
      this.dir = null;
      this.content = null;
      if (d) {
        this.form.name.en = d.name.en;
        this.form.name.id = d.name.id;
        this.form.descriptions.en = (d.descriptions) ? d.descriptions.en : '';
        this.form.descriptions.id = (d.descriptions) ? d.descriptions.id : '';
        this.form.breadcrumb.model = d.breadcrumb;
        this.form.type.model = d.type;
        if (['Page', 'Pages'].includes(d.type)) {
          if (this.pages.length < 1) {
            this.getPages(() => {
              this.setPageModel();
              this.setPageModelFromD(d);
            });
          } else {
            this.setPageModel();
            this.setPageModelFromD(d);
          }
        } else if (d.type === 'Directory') {
          this.dir = d.directory;
        } else if (d.type === 'Content') {
          this.content = d.content;
        }
      } else {
        // eslint-disable-next-line
        if (this.pages.length < 1) {
          this.getPages(() => {
            this.setPageModel();
          });
        } else {
          this.setPageModel();
        }
      }
      setTimeout(() => {
        this.$refs.input.focus();
      });
    },
    close(b, v) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
    setPageModelFromD(d) {
      if (d.type === 'Page' && d.page) {
        this.form.page.model = d.page.id;
      } else if (d.type === 'Pages' && d.pages && d.pages.length > 0) {
        this.form.pages.model = [];
        // eslint-disable-next-line
        for (const page of d.pages) {
          this.form.pages.model.push({ id: page.id });
        }
      }
    },
    setPageModel() {
      this.form.page.model = (this.pages.length > 0) ? this.pages[0].id : '';
      this.form.pages.model = (this.pages.length > 0) ? [{ id: this.pages[0].id }] : '';
    },
    addPage() {
      const pageId = (this.pages.length > 0) ? this.pages[0].id : '';
      this.form.pages.model.push({ id: pageId });
    },
    selectDir() {
      this.$refs.contentDirSelector.open(null, (b, v) => {
        if (!b) return;
        this.dir = v;
        if (!this.form.name[this.lang]) this.form.name[this.lang] = v.name;
      });
    },
    selectContent() {
      this.$refs.articleSelector.open(null, (b, v) => {
        if (!b) return;
        if (v.type === 'custom_link') {
          if (!this.form.name.model) this.form.name.model = v.title;
          this.form.url.model = v.url;
          this.form.type.model = 'External Link';
          return;
        }
        this.content = v;
        if (!this.form.name[this.lang]) this.form.name[this.lang] = v.title;
      });
    },
    getPages(next) {
      this.loadingPage = true;
      this.$http.get(this.$config.uri('page/all')).then((r) => {
        this.loadingPage = false;
        this.pages = (r.data.status === 200) ? r.data.data : [];
        if (next) next(r.data);
      });
    },
    handleSubmit() {
      const formData = {
        name: {
          en: this.form.name.en,
          id: this.form.name.id,
        },
        descriptions: {
          en: this.form.descriptions.en,
          id: this.form.descriptions.id,
        },
        type: this.form.type.model,
        breadcrumb: this.form.breadcrumb.model,
        status: 'published',
        viewCount: 0,
        collapsed: false,
        submenus: [],
      };
      if (!formData.name) {
        this.form.name.error = 'Please input menu name';
        return;
      }
      if (formData.type === 'Page') {
        // eslint-disable-next-line
        for (const item of this.pages) {
          if (item.id === parseInt(this.form.page.model, 10)) {
            formData.page = item;
            break;
          }
        }
      } else if (formData.type === 'Pages') {
        formData.pages = [];
        // eslint-disable-next-line
        for (const p of this.form.pages.model) {
          // eslint-disable-next-line
          for (const item of this.pages) {
            if (item.id === parseInt(p.id, 10)) {
              formData.pages.push(item);
              break;
            }
          }
        }
      } else if (formData.type === 'Content') {
        formData.content = this.content;
      } else if (formData.type === 'Directory') {
        formData.directory = this.dir;
      } else if (formData.type === 'External Link') {
        formData.link = this.form.url.model;
      }
      this.close(true, formData);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      width: 320px;
      .formCnt{
        max-height: 46vh;
        overflow: auto;
        margin: 10px -40px -30px;
        border-top: #eee 1px solid;
        padding: 0 40px 30px;
        .fieldGroup{
          .btnAdd{
            margin: 0 !important;
          }
        }
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 5px;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .fieldGroup{
        margin: 20px 0 0;
      }
      .fieldCnt.pages{
        margin-bottom: 10px;
      }
      .dirSelected{
        padding-left: 30px;
        display: block;
        padding-right: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &:before{
          content: "";
          position: absolute;
          left: 14px; top: 0; bottom: 0;
          width: 16px;
          background-image: url(../assets/directory.png);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .65;
        }
      }
      .productItem{
        position: relative;
        box-sizing: border-box;
        padding-left: 50px;
        min-height: 38px;
        padding-right: 36px;
        .thumb{
          left: 0; top: 0;
          position: absolute;
          width: 38px; height: 38px;
          background-color: #e5e5e5;
          background-size: cover;
          background-position: top center;
          background-repeat: no-repeat;
          border-radius: 4px;
          opacity: 1;
          display: inline-block;
          &.noImg{
            background-image: url(../assets/image-white.png);
            background-size: 24px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
        h4{
          margin: 0;
          padding: 0;
          border: none;
          font-size: 16px;
          font-weight: 600;
        }
        p{
          margin: 0;
          color: #767676;
          font-size: 14px;
          line-height: 1.23;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 20px;
        text-align: right;
        border-top: #eee 1px solid;
        display: flex;
        align-items: center;
        .langSelectorBtn{
          margin-right: auto;
          position: relative;
          border-radius: 50px;
          padding: 6px 16px;
          padding-left: 36px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover{
            background-color: #f5f5fe;
          }
          &:before{
            content: "";
            position: absolute;
            left: 12px; top: 0; bottom: 3px;
            width: 18px;
            background-image: url(../assets/language.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          b{
            font-weight: 600;
            text-transform: uppercase;
          }
          .langSelector{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            bottom: 100%; left: 0;
            box-shadow: 0 0 6px rgba(0, 0, 0, .2);
            border-radius: 5px;
            padding: 8px 0;
            text-align: left;
            li{
              white-space: nowrap;
              list-style: none;
              padding: 8px 24px;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .btn{
          margin-left: 10px;
          &.btnSecondary{
            margin-left: auto;
          }
        }
      }
    }
  }
</style>
